<template>
  <div class="container sign-in">
    <article class="intro">
      <template v-if="focused === ''">
        <h3 class="tit">{{ $t('label.lgAccLogin') }}</h3>
        <p class="desc" v-html="$t('messages.lgSignInTxt')"></p>
      </template>
      <template v-if="focused === 'ID'">
        <h3 class="tit">{{ $t('label.lgAccId') }}</h3>
      </template>
      <template v-if="focused === 'PASS'">
        <h3 class="tit">{{ $t('label.lgAccPass') }}</h3>
      </template>
    </article>
    <section class="sign-in-form">
      <b-form autoComplete="off">
        <label for="id" v-if="focused === ''">{{ $t('label.id') }}</label>
        <b-form-input class="focusable" :class="{'hid': focused==='PASS'}" tabindex="0" onfocus="this.removeAttribute('readonly');" v-model="email" type="email" :placeholder="$t('label.idPlaceholder')"
                      id="id" ref="email" @keyup.down="$refs.pass.focus()" @keyup.enter="onPwFocus" @focus="onIdFocus" @keyup="error=''" autoComplete="false"></b-form-input>
        <label for="pw" v-if="focused === ''">{{ $t('label.pw') }}</label>
        <b-form-input class="focusable" :class="{'hid': focused==='ID'}" tabindex="0" v-model="pass" :type="type" :readonly="isPwReadOnly" :placeholder="$t('label.pwPlaceholder')"
                      id="pw" ref="pass" @keyup.down="$refs.close.focus()" @keyup.enter="onSubmit" @keyup.up="$refs.email.focus()" @focus="onPwFocus" @keyup="error=''" autoComplete="false"></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
          {{ error }}
        </b-form-invalid-feedback>
        <template v-if="focused === 'PASS'">
          <p class="checkbox-wrap">
            <b-form-checkbox v-model="showPass">{{ $t('label.showPass') }}</b-form-checkbox>
          </p>
        </template>
      </b-form>
      <div class="btn-wrap">
        <b-button class="focusable" tabindex="0" ref="close" @click="goPage('Login')" v-if="focused === '' || focused === 'ID'">{{ $t('label.cancel') }}</b-button>
        <b-button class="focusable" tabindex="0" @click="onPwFocus" v-if="focused === 'ID'">{{ $t('label.next') }}</b-button>
        <b-button class="focusable" tabindex="0" @click="onIdFocus" v-if="focused === 'PASS'">{{ $t('label.prev') }}</b-button>
        <b-button class="focusable" tabindex="0" ref="login" @click="onSubmit" v-if="focused === '' || focused === 'PASS'">{{ $t('label.signIn') }}</b-button>
      </div>
    </section>
  </div>
</template>
<script>
import CryptoJS from "crypto-js";

export default {
  name: 'LgLogin',
  metaInfo() {
    return {
      title: "LgLogin"
    };
  },
  data() {
    return {
      email: '',
      pass: '',
      country_code: this.$store.state.country || this.$route.query.country,
      action: `${process.env.VUE_APP_API_SERVER}/authorize`,
      login_save: this.$store.state.login_save || this.$route.query.login_save,
      redirect_uri: this.$store.state.redirect_uri || this.$route.query.redirect_uri,
      showPass: '',
      error: '',
      focused: '',
      isPwReadOnly: true,
      loginType: {
        'GGL': {
          'NAME': this.$i18n.t('label.google'),
          'MSG': this.$i18n.t('label.googleLogin')
        },
        'FBK': {
          'NAME': this.$i18n.t('label.facebook'),
          'MSG': this.$i18n.t('label.facebookLogin')
        },
        'AMZ': {
          'NAME': this.$i18n.t('label.amazon'),
          'MSG': this.$i18n.t('label.amazonLogin')
        },
        'NAV': {
          'NAME': this.$i18n.t('label.naver'),
          'MSG': this.$i18n.t('label.naverLogin')
        }
      }
    }
  },
  mounted() {
    this.focused = '';
  },
  computed: {
    type: function() {
      return this.showPass ? 'text' : 'password'
    }
  },
  methods: {
    checkForm(mode) {
      this.error = '';
      if (!this.email) {
        this.error = this.$t('messages.InputID');
        if (this.focused === 'PASS') this.focused = 'ID'
        this.$refs.email.focus()
        return false;
      }
      if (!this.validEmail(this.email)) {
        this.error = this.$t('messages.InvalidEmail');
        if (this.focused === 'PASS') this.focused = 'ID'
        this.$refs.email.focus()
        return false;
      }
      if (!this.pass && mode !== 'ID') {
        this.error = this.$t('messages.InputPassword');
        if (this.focused === 'ID') this.focused = 'PASS'
        this.$refs.pass.focus()
        return false;
      }
      return true;
    },
    validEmail: function(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    onIdFocus() {
      this.focused = 'ID';
      this.$nextTick(() => {
        this.$refs.email.focus()
      })
    },
    onPwFocus() {
      if (this.focused === 'ID' || this.focused === 'PASS') {
        if (!this.checkForm('ID')) return false;
        this.focused = 'PASS';
        this.isPwReadOnly = false;
        this.$nextTick(() => {
          this.$refs.pass.focus()
        })
      } else {
        this.focused = 'ID';
        this.$nextTick(() => {
          this.$refs.email.focus()
        })
      }
    },
    async onSubmit(event) {
      event.preventDefault();
      if (!this.checkForm('LOGIN')) return false;
      let passwordInSha512 = CryptoJS.SHA512(this.pass).toString(CryptoJS.enc.Hex);
      let param = {
        id: this.email,
        password: passwordInSha512,
        country_code: this.country_code,
        login_save: this.login_save,
        redirect_uri: this.redirect_uri,
        svc_list: this.$store.state.svc_list,
        language: this.$store.state.language,
        cross_login: this.$store.state.cross_login,
        except_new: this.$store.state.except_new,
        terms_name: this.$store.state.terms_name,
        third_party_service_name: this.$store.state.third_party_service_name,
        show_login_type: this.$store.state.show_login_type,
        response_type: this.$store.state.response_type,
        client_id: this.$store.state.client_id,
        state: this.$store.state.state
      }
      this.$axios.post(
          `${process.env.VUE_APP_API_SERVER}/authorize`,
          param
      ).then(res => {
        if (res.status === 200) {
          this.$toastr.s(this.$t('messages.SignInComplete', {'0': this.$t('label.lgAccount')}))

          const locale = navigator.language || navigator.userLanguage;
          if (locale.indexOf('CA') < 0) {
            gtag('event', "login_complete", {
              "method": "LgLogin",
              "country_code": this.country_code,
              "login_save": this.autoSignIn
            });
          }

          setTimeout(() => {
            window.location.href = res.data.location;
          }, 1500)
        }
      }).catch(err => {
        if (err.response.status === 406) {
          const errName = err.response.data.error.name;
          let popType = 'OK';
          if (errName) {
            let msg = ''
            if (errName === 'WrongCountryCodeException') {
              if (this.country_code && ['KR', 'US', 'CA'].includes(this.country_code)) msg = this.$t(`messages.${errName}`, {'0': this.country_code});
              else msg = this.$t(`messages.${errName}2`);
            } else if (errName === 'WrongCountryCode') {
              popType = 'CONFIRM';
              let countryName = this.$t(`label.${err.response.data.error.message}`)
              msg = this.$t(`messages.${errName}`, {'0': countryName});
            } else if (errName === 'Already3rdPartyRegistrationException') {
              const type = err.response.data.error.message.substring(err.response.data.error.message.length - 3);
              popType = 'CONFIRM';
              msg = this.$t(`messages.${errName}`, {
                '0': this.loginType[type].NAME,
                '1': this.loginType[type].MSG
              });
            } else if (errName === 'WrongPasswordException') {
              popType = 'pwErr';
              this.error = this.$t(`messages.${errName}`);
            } else {
              msg = this.$t(`messages.${errName}`);
            }
            if (popType === 'OK') {
              this.$bvModal.msgBoxOk(msg, {
                okTitle: this.$t('label.ok')
              })
            } else if (popType === 'CONFIRM') {
              this.$bvModal.msgBoxConfirm(msg, {
                okTitle: this.$t('label.ok'),
                cancelTitle: this.$t('label.cancel'),
              }).then(value => {
                if (value) this.$router.push({name: 'Login'})
              })
            }
          } else {
            this.$bvModal.msgBoxOk(this.$t(`messages.SignInError`), {
              okTitle: this.$t('label.ok')
            }).then(value => {
              if (value) this.onIdFocus()
            })
          }
        } else {
          this.$bvModal.msgBoxOk(this.$t(`messages.SignInError`), {
            okTitle: this.$t('label.ok')
          }).then(value => {
            if (value) this.onIdFocus()
          })
        }
      });
    },
    keyup: function(e) {
      e.preventDefault();
      this.error = ''
      if (e.keyCode === 461) {
        this.goPage('Login')
      }
    },
    goPage: function(page) {
      this.$router.push({
        name: page
      });
    },
    goMainPage() {
      document.location.href = "/";
    }
  }
}
</script>
<style>
.hid {
  visibility: hidden;
}
</style>
